// extracted by mini-css-extract-plugin
module.exports = {"link":"TextLink_link__C7pva"};